import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import CoachingAgendaCard from 'components/dashboard/CoachingAgendaCard';
import Button from '@material-ui/core/Button';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import User from 'records/User';
import AgendaColumnHeader from 'components/dashboard/AgendaColumnHeader';
import {CoachingReviewTypeDisplayAndChooser} from 'components/dashboard/common/CoachingReviewTypeDisplayAndChooser';
import AgendaMeetingLink from 'components/dashboard/AgendaMeetingLink';

export default class RepPendingAgendaColumn extends React.PureComponent {
  render() {
    const {reviews, reviewTypes, plans, sessionUser, selectedPlanId} = this.props;
    return (
      <div className="rep-column agenda-column">
        <AgendaColumnHeader
          popoverMessage="These coaching meetings require action on the rep's part before review preparation is complete. Hover over each meeting to send a reminder to each rep."
          title="Pending Rep Action"
        />
        {reviews.isEmpty() ? (
          <div className="rep-empty empty-agenda">
            <div className="check-icon" />
            <div className="empty-descr">Your reps are caught up!</div>
          </div>
        ) : (
          reviews.map(r => {
            return (
              <CoachingAgendaCard
                rep={r.coachingPlan.recipient.info}
                className={selectedPlanId === r.planId ? 'selected blink' : ''}
                key={r.id}
                pendingType="REP"
                onEditPlan={this.props.onEditPlan}
                refreshCoachingData={this.props.refreshCoachingData}
                review={r}
                plans={plans}>
                <div>
                  <CoachingReviewTypeDisplayAndChooser
                    review={r}
                    reviewTypes={reviewTypes}
                    onSetReviewType={this.props.onSetReviewType}
                  />
                  <div className="rep-cta">
                    {r.rep.firstName} needs to {r.otherParticipantTodo.toPhrase()} before the
                    meeting.
                  </div>
                  {r.canSendReminder() ? (
                    <Button
                      variant="outlined"
                      className="ev-button"
                      fullWidth
                      onClick={() => UpcomingReviewsActions.sendReminder(sessionUser.id, r.id)}>
                      Send Reminder
                    </Button>
                  ) : (
                    <div className="reminder-alert">
                      Reminder sent at {r.reminderSentAt.format('M/D/YY h:mmA')}
                    </div>
                  )}
                  <AgendaMeetingLink review={r} />
                </div>
              </CoachingAgendaCard>
            );
          })
        )}
      </div>
    );
  }
}

RepPendingAgendaColumn.propTypes = {
  sessionUser: PropTypes.instanceOf(User),
  reviews: PropTypes.instanceOf(List), // List<CoachingReview>
};
